import React, { Component } from 'react';
import Autocomplete from '../common/autocomplete';
import DateInput from '../common/date/';
import strings from '../locales/';

const Header = props => (
  <div className="header between">
    <div className="header_box_filter">
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.detail_waiting_times.fufillment.operation}</label>
        </div>
        <div>
          <Autocomplete
            value={`TODOS`}
            id={`au-0`}
            alias="alias"
            select="alias"
            idItem="id"
            filter={[{ alias: 'Cristóbal', id: 0 }, { alias: 'Fernanda', id: 1 }]}
            handleSubmit={props.handleSubmit}
          />
        </div>
      </div>
      <div className="box-form islabel box170">
        <div>
          <label>{props.language.detail_waiting_times.fufillment.date}</label>
        </div>
        <DateInput
          dateFrom={1532985125137}
          dateTo={1532985125137}
          difFrom={-1209600000}
          difTo={0}
        />
      </div>
    </div>
    <div className="header_box_filter" />
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/driver_fulfillment/header.jsx